import React, { useState } from 'react'
import { TaskCard } from '../../types/task-board'

interface TaskCardDescriptionProps {
  card: TaskCard
  onUpdateDescription: (cardId: string, description: string) => Promise<void>
}

export const TaskCardDescription: React.FC<TaskCardDescriptionProps> = ({ card, onUpdateDescription }) => {
  const [isEditing, setIsEditing] = useState(false)
  const [description, setDescription] = useState(card.description || '')

  const handleSave = () => {
    onUpdateDescription(card.id, description)
    setIsEditing(false)
  }

  const handleCancel = () => {
    setDescription(card.description || '')
    setIsEditing(false)
  }

  return (
    <div style={{
      border: '1px solid #e9ecef',
      borderRadius: '5px',
      marginBottom: '20px',
      padding: window.innerWidth < 768 ? '10px' : '15px',
      backgroundColor: '#fff'
    }}
    >
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: window.innerWidth < 768 ? '8px' : '10px'
      }}
      >
        <h4 style={{
          fontSize: window.innerWidth < 768 ? '15px' : '16px',
          fontWeight: 600,
          margin: 0
        }}
        >
          Opis zadania
        </h4>
        {!isEditing && (
          <button
            onClick={() => setIsEditing(true)}
            style={{
              backgroundColor: 'transparent',
              border: 'none',
              color: '#007bff',
              fontSize: '13px',
              cursor: 'pointer',
              padding: '3px 8px',
              borderRadius: '3px'
            }}
          >
            Edytuj
          </button>
        )}
      </div>
      {isEditing
        ? (
          <div>
            <textarea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              style={{
                width: '100%',
                padding: '8px',
                borderRadius: '4px',
                border: '1px solid #ced4da',
                fontSize: '14px',
                minHeight: '100px',
                marginBottom: '10px',
                resize: 'vertical'
              }}
            />
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <button onClick={handleCancel} style={{ backgroundColor: '#6c757d', border: 'none', padding: '5px 10px', color: 'white', borderRadius: '3px', fontSize: '13px', marginRight: '8px', cursor: 'pointer' }}>
                Anuluj
              </button>
              <button onClick={handleSave} style={{ backgroundColor: '#28a745', border: 'none', padding: '5px 10px', color: 'white', borderRadius: '3px', fontSize: '13px', cursor: 'pointer' }}>
                Zapisz
              </button>
            </div>
          </div>
          )
        : (
          <p style={{ margin: 0, fontSize: '14px', lineHeight: 1.5, wordBreak: 'break-word' }}>
            {card.description || 'Brak opisu'}
          </p>
          )}
    </div>
  )
}
